import React, { useState } from 'react';
import { removeDefaultParams } from '../../../Utils/helper';
import { useRouter } from 'next/router';
import { CategoryItems } from './styled';
import Image from 'next/image';
import Link from 'next/link';
import { fireClickedCardEvent } from '../staticData';

function OvulationCategoriesInner(props) {
  const { element } = props;
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState();
  const categoryOnClick = () => {
    fireClickedCardEvent('', element?.text, element?.web_url);
    setClickEffect('lowOpacity');
    setTimeout(() => {
      setClickEffect('');
    }, 200);
  };
  return (
    <Link
      href={{
        pathname: element?.web_url,
        query: removeDefaultParams(router.query),
      }}
      locale={false}
      passHref
      legacyBehavior
    >
      <CategoryItems onClick={categoryOnClick} as="a">
        <div className={`categoryImage ${clickEffect} `}>
          <Image src={element?.image} quality={90} alt="" fill sizes="100vw" />
        </div>
        <p className="categoryName">{element?.text}</p>
      </CategoryItems>
    </Link>
  );
}

export default OvulationCategoriesInner;
